import { BehaviorSubject, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { InjectionToken, Injectable, Inject, NgModule, defineInjectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService, TranslateModule, TranslateLoader, TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/translation-config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TranslationConfigService = new InjectionToken('TranslationConfig');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/translation.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TranslationService = /** @class */ (function () {
    function TranslationService(translateService, config) {
        this.translateService = translateService;
        this.config = config;
        this._isReady$ = new BehaviorSubject(false);
        this.subscriptions = new Subscription();
        this.isReady$ = this._isReady$.asObservable();
    }
    Object.defineProperty(TranslationService.prototype, "isReady", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isReady$.value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} key
     * @param {?=} context
     * @return {?}
     */
    TranslationService.prototype.get = /**
     * @param {?} key
     * @param {?=} context
     * @return {?}
     */
    function (key, context) {
        return this.translateService.instant(key, context);
    };
    /**
     * @return {?}
     */
    TranslationService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.unsubscribe();
    };
    /**
     * @return {?}
     */
    TranslationService.prototype.initialise = /**
     * @return {?}
     */
    function () {
        if (this.isReady) {
            return true;
        }
        return this.beginLoadingLanguage();
    };
    /**
     * @protected
     * @return {?}
     */
    TranslationService.prototype.beginLoadingLanguage = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        try {
            /** @type {?} */
            var runtimeLanguage = this.translateService.getBrowserLang().split('-')[0];
            if (runtimeLanguage === this.config.defaultLanguage) {
                // nothing to load in, English text is baked into the templates r.n.
                return this.finishLoadingLanguage();
            }
            if (Object.keys(this.config.languages).indexOf(runtimeLanguage) === -1) {
                // not a supported language, bail out to prevent a 404 when trying to fetch translations.
                return this.finishLoadingLanguage();
            }
            // Set language, used by some browser extensions.
            document.documentElement.setAttribute('lang', runtimeLanguage);
            if (this.config.languages[runtimeLanguage].isRTL) {
                // if RTL, add a class for performant RTL-specific styling elsewhere.
                document.body.classList.add('text-direction-rtl');
            }
            // we defer display of the UI to allow time for the translations to load in, which allows us to be
            // synchronous elsewhere in the application when retrieving translation values.
            this.subscriptions.add(this.translateService.use(runtimeLanguage).subscribe({
                complete: (/**
                 * @return {?}
                 */
                function () { return _this.finishLoadingLanguage(); }),
                error: (/**
                 * @return {?}
                 */
                function () { return _this.finishLoadingLanguage(); }),
            }));
            return true;
        }
        catch (error) {
            // silently fail
            return false;
        }
    };
    /**
     * @protected
     * @return {?}
     */
    TranslationService.prototype.finishLoadingLanguage = /**
     * @protected
     * @return {?}
     */
    function () {
        try {
            this._isReady$.next(true);
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    };
    TranslationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TranslationService.ctorParameters = function () { return [
        { type: TranslateService },
        { type: undefined, decorators: [{ type: Inject, args: [TranslationConfigService,] }] }
    ]; };
    /** @nocollapse */ TranslationService.ngInjectableDef = defineInjectable({ factory: function TranslationService_Factory() { return new TranslationService(inject(TranslateService), inject(TranslationConfigService)); }, token: TranslationService, providedIn: "root" });
    return TranslationService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/translation.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} http
 * @return {?}
 */
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
var TranslationModuleForRoot = /** @class */ (function () {
    function TranslationModuleForRoot() {
    }
    TranslationModuleForRoot.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: HttpLoaderFactory,
                                deps: [HttpClient]
                            },
                            useDefaultLang: true,
                        })
                    ],
                    exports: [
                        TranslatePipe,
                        TranslateDirective
                    ]
                },] }
    ];
    return TranslationModuleForRoot;
}());
var TranslationModuleForChild = /** @class */ (function () {
    function TranslationModuleForChild() {
    }
    TranslationModuleForChild.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        TranslateModule,
                    ],
                    exports: [
                        TranslatePipe,
                        TranslateDirective
                    ]
                },] }
    ];
    return TranslationModuleForChild;
}());
var TranslationModule = /** @class */ (function () {
    function TranslationModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    TranslationModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: TranslationModuleForRoot,
            providers: [
                TranslationService, {
                    provide: TranslationConfigService,
                    useValue: config
                },
            ]
        };
    };
    /**
     * @return {?}
     */
    TranslationModule.forChild = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: TranslationModuleForChild,
            providers: [
                TranslationService
            ]
        };
    };
    TranslationModule.decorators = [
        { type: NgModule }
    ];
    return TranslationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/translation.interfaces.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: examsoft-translation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TranslationService, HttpLoaderFactory, TranslationModuleForRoot, TranslationModuleForChild, TranslationModule, TranslationConfigService as ɵa };

//# sourceMappingURL=examsoft-translation.js.map